// extracted by mini-css-extract-plugin
export default {"toolbarExportButton":"SeizedCommodities_toolbarExportButton__vvaNY","exportableTable":"SeizedCommodities_exportableTable__sfzBt"};